import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';

export const ContextHighlight = styled.ellipse`
  stroke-width: 2px;
  stroke: ${colors.blue400};
  fill: ${colors.blue400};
  fill-opacity: 0.32;
`;

export const SelectedRelatedHighlight = styled.ellipse`
  stroke-width: 0;
  stroke: transparent;
  fill: #e9cbe6;
  pointer-events: none;
`;
